import {Box, Skeleton} from '@viptech/react-components'

export function HistoryPhotoFrameSkeleton() {
  return (
    <>
      <Box width='fit-content' height='fit-content' padding='8px' backgroundColor={'#F2F4F7'} style={{cursor: 'pointer', outlineOffset: '4px'}}>
        <Box width='128px' display='flex' rowGap='8px' direction='column'>
          <Skeleton width='128px' height='136px' />

          <Box>
            <Skeleton width='48px' height='10px' borderRadius='8px' />
            <Box display='flex' justify='space-between'>
              <Skeleton width='48px' height='10px' borderRadius='8px' />
              <Skeleton width='32px' height='10px' borderRadius='8px' />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export function HistoryPhotoFrameSkeletonMap() {
  return new Array(12).fill(null).map((_, i) => <HistoryPhotoFrameSkeleton key={i} />)
}
